import React, { useContext } from 'react';
import { ButtonBase } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { StateContext } from '../context/StateProvider';

/**
 * Franja que muestra/oculta el header de la aplicación
 */
export default function ToggleHeaderButton() {
    const { state, updateState } = useContext(StateContext);

    return (
        <ButtonBase
            title={state.headerVisible ? 'Ocultar cabecera' : 'Mostrar cabecera'}
            onClick={() => updateState({ headerVisible: !state.headerVisible })}
            sx={{
                width: '100%',
                height: 24,
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #e9ecef',
                color: '#6c757d',
                transition: 'background-color 0.2s, color 0.2s',
                '&:hover': {
                    backgroundColor: '#e9ecef',
                    color: '#495057',
                },
            }}
        >
            {state.headerVisible
                ? <ExpandLessIcon sx={{ fontSize: 18 }} />
                : <ExpandMoreIcon sx={{ fontSize: 18 }} />}
        </ButtonBase>
    );
}
